module.exports = __webpack_public_path__ + "06_mole.380362fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer2/06_mole.png
// module id = D2EN
// module chunks = 0